module.exports = __webpack_public_path__ + "media/Loops 90 Vocals.20b87f6a.wav";